import constants from '../helpers/constants';

const HEADER_ELEMENT = {
    wrapper: '#header',
    headerNavId: '#header-nav',
    flexedClassName: 'is-fixed',
    pageWrapper: '.m-page-wrap'
};

const state = {
    header: null,
    nav: null,
    headerNavHeight: 0,
};

const callback = (entries) => {
    if (window.innerWidth < constants.desktopWidth) return false;

    const pageWrapper = document.querySelector(HEADER_ELEMENT.pageWrapper);

    entries.forEach((entry) => {
        if (entry.isIntersecting) {
            state.header.classList.remove(HEADER_ELEMENT.flexedClassName);
            pageWrapper.style.paddingTop = 0;
        } else {
            state.header.classList.add(HEADER_ELEMENT.flexedClassName);
            pageWrapper.style.paddingTop = `${state.headerNavHeight}px`;
        }
    });
};

function fixedHeader() {
    const targetElement = document.querySelector(HEADER_ELEMENT.wrapper);

    if (!targetElement) { return false; }

    state.header = targetElement;
    state.nav = targetElement.querySelector(HEADER_ELEMENT.headerNavId);
    state.headerNavHeight = state.nav.offsetHeight;
    const headerHeight = targetElement.offsetHeight;
    document.documentElement.style.setProperty('--headerHeight', `${headerHeight}px`);

    const options = {
        rootMargin: `-${state.headerNavHeight}px 0px 0px 0px`
    };

    const observer = new IntersectionObserver(callback, options);
    observer.observe(targetElement);
}

export default fixedHeader;
